//上部画像の設定
$('.gallery').slick({
	infinite: true, //スライドをループさせるかどうか。初期値はtrue。
	fade: true, //フェードの有効化
	arrows: true,//左右の矢印あり
	dots: true, // ドットの有効化
	prevArrow: '<div class="slick-prev"></div>',//矢印部分PreviewのHTMLを変更
	nextArrow: '<div class="slick-next"></div>',//矢印部分NextのHTMLを変更
});

//選択画像の設定
$('.choice-btn').slick({
	infinite: true, //スライドをループさせるかどうか。初期値はtrue。
	slidesToShow: 8, //表示させるスライドの数
	focusOnSelect: true, //フォーカスの有効化
	asNavFor: '.gallery', //連動させるスライドショーのクラス名
});


//下の選択画像をスライドさせずに連動して変更させる設定。
//$('.gallery').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
//	var index = nextSlide; //次のスライド番号
	//サムネイルのslick-currentを削除し次のスライド要素にslick-currentを追加
//	$(".choice-btn .slick-slide").removeClass("slick-current").eq(index).addClass("slick-current");
//});

$(document).ready(function () {
    // ギャラリーの初期化
    $('.gallery').slick({
        infinite: true, //スライドをループ
        fade: true,     //フェードの有効化
        arrows: true,   //左右の矢印
        dots: true,     //ドットを表示
        asNavFor: '.choice-btn' // サムネイルと連動
    });

    // 選択画像の初期化
    $('.choice-btn').slick({
        infinite: true,        //スライドをループ
        slidesToShow: 8,       //表示スライド数
        focusOnSelect: true,   //フォーカスの有効化
        asNavFor: '.gallery'   //連動するスライド
    });

    // レスポンシブ対応でスライダーを切り替える関数
    function initChoiceSlider() {
        if ($(window).width() <= 1023) {
            // スマホではSlickを削除
            if ($('.choice-btn').hasClass('slick-initialized')) {
                $('.choice-btn').slick('unslick'); // Slickを破棄
            }
        } else {
            // PCではSlickを再初期化
            if (!$('.choice-btn').hasClass('slick-initialized')) {
                $('.choice-btn').slick({
                    infinite: true,
                    slidesToShow: 8,
                    focusOnSelect: true,
                    asNavFor: '.gallery',
                });
            }
        }
    }

    // ページロード時に初期化
    initChoiceSlider();

    // ウィンドウリサイズ時にも初期化
    $(window).resize(function () {
        initChoiceSlider();
    });
});

/*
$(document).ready(function () {
    function initChoiceSlider() {
        if ($(window).width() <= 1023) {
            // スマホではSlickを削除
            if ($('.choice-btn').hasClass('slick-initialized')) {
                $('.choice-btn').slick('unslick'); // Slickを破棄
            }
        } else {
            // PCではSlickを再初期化
            if (!$('.choice-btn').hasClass('slick-initialized')) {
                $('.choice-btn').slick({
                    infinite: true,
                    slidesToShow: 8,
                    focusOnSelect: true,
                    asNavFor: '.gallery',
                });
            }
        }
    }

    // ページロード時に適用
    initChoiceSlider();

    // リサイズ時にも適用
    $(window).resize(function () {
        initChoiceSlider();
    });
});

$jQuery.noConflict();
jQuery(document).ready(function ($) {
    $('.gallery').slick({
        infinite: true,
        fade: true,
        arrows: true,
        dots: true
    });
});
*/
